module.exports = __webpack_public_path__ + "static/media/ic_desktop.96885d1d.svg";